import { connect, ConnectedProps } from "react-redux";

import { IStoreState } from "../../../../reducers/types";
import {
  getAdultsCount,
  getChildren,
  getFromDate,
  getUntilDate,
} from "../../../search/reducer";
import { WishlistManagementModal } from "./component";
import { getHotelsAvailabilityPetsCount } from "../../../availability/reducer";
import { History } from "history";
import { FavoritesEntryType } from "redmond";

interface IStateProps {
  fromDate: Date | null;
  untilDate: Date | null;
  adultsCount: number;
  childrenCount: number[];
  searchedPetsCount: number;
}

export interface IOwnProps {
  history: History;
  entryType?: FavoritesEntryType;
}

interface IDispatchProps {}

const mapDispatchToProps = {};

const mapStateToProps = (state: IStoreState): IStateProps => ({
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  adultsCount: getAdultsCount(state),
  childrenCount: getChildren(state),
  searchedPetsCount: getHotelsAvailabilityPetsCount(state),
});

const mergeProps = (
  stateProps: IStateProps,
  dispatchProps: IDispatchProps,
  ownProps: IOwnProps
) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type WishlistManagementModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedWishlistManagementModal = connector(
  WishlistManagementModal
);
